import Link from 'next/link';
import React from 'react';

interface LinkLikeComponentProps extends React.HTMLProps<HTMLAnchorElement> {
  /** The url to link to */
  url: string;
  /**	The content to display inside the link */
  children?: React.ReactNode;
  /** Makes the link open in a new tab */
  external?: boolean;
  /** Makes the browser download the url instead of opening it. Provides a hint for the downloaded filename if it is a string value. */
  download?: string | boolean;
  [key: string]: any;
}

// This component is only used in _app.tsx to translate Polaris links into Nextjs links.
// It should not be used directly.
export const LinkWrapper = (props: LinkLikeComponentProps) => {
  const { children, url, ...rest } = props;

  return (
    <Link href={url}>
      <a {...rest} target={props.external && '_blank'}>
        {children}
      </a>
    </Link>
  );
};
